(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  var itemsUploading = 0;
  var contactMenuSelector = document.querySelector('#page-contact-how-can-we-help');
  contactMenuSelector.selectedIndex = 0;
  
  contactMenuSelector.onchange = function(e) {
    if (! e.target.value) {
      return;
    }
    var targetOption = e.target.value.toLowerCase(); 

    resetAllContainers();
    switch(targetOption) {
      case "order status":
      case "shipping & tracking":
      case "cancelations":
        displayContainer('page-contact-order-number', true);
        break;
      case "returns":
        displayContainer('page-contact-order-number', true);
        displayContainer('page-contact-returns-image', true);
        break;
      case "update delivery address":
        displayContainer('page-contact-order-number', true);
        displayContainer('page-contact-warranty-claim-shipping-address-new-address', true);
        break;
      case "defects & warranty claims":
        displayContainer('page-contact-order-number', true);
        displayContainer('page-contact-warranty-claim-what-product-affected', true);
        // disable submission
        document.getElementById('nugget_form_submit').disabled = true;
        document.getElementById('nugget_form_submit_message').classList.remove('hidden');
        document.getElementById('nugget_form_submit_message').innerHTML = 'Please include at least one impact and one lot tag image to submit your claim.';
        break;
      default:
        resetAllContainers();
        break;
    }

  };

  var productMenuSelector = document.querySelector('#page-contact-warranty-claim-what-product-affected');
  productMenuSelector.selectedIndex = 0;
  
  productMenuSelector.onchange = function(e) {
    if (! e.target.value) {
      return;
    }
    var targetOption = e.target.value.toLowerCase(); 

    switch(targetOption) {
      case "the nugget":
          displayContainer('page-contact-warranty-claim-which-piece-affected', true);
          displayContainer('page-contact-warranty-claim-which-piece-affected-chunk', false);
          displayContainer('page-contact-warranty-claim-where-issue-on-nugget', true);
          displayContainer('page-contact-warranty-claim-where-issue-on-chunk', false);
          displayContainer('page-contact-warranty-claim-what-is-color-name', true);
          displayContainer('page-contact-warranty-claim-what-is-color-name-chunk', false);
          displayContainer('page-contact-warranty-claim-shipping-address', true);
          displayContainer('page-contact-warranty-claim-lot-tag', true);
          displayContainer('page-contact-warranty-claim-impact-area', true);
          document.getElementById('page-contact-warranty-claim-lot-tag-nugget-container').style.display = 'inline';
          document.getElementById('page-contact-warranty-claim-lot-tag-chunk-container').style.display = 'none';
          document.getElementById('tag-lot-container-nugget').style.display = 'inline';
        break;
        case "chunk":
          displayContainer('page-contact-warranty-claim-which-piece-affected', false);
          displayContainer('page-contact-warranty-claim-which-piece-affected-chunk', true);
          displayContainer('page-contact-warranty-claim-where-issue-on-nugget', false);
          displayContainer('page-contact-warranty-claim-where-issue-on-chunk', true);
          displayContainer('page-contact-warranty-claim-what-is-color-name', false);
          displayContainer('page-contact-warranty-claim-what-is-color-name-chunk', true);
          displayContainer('page-contact-warranty-claim-shipping-address', true);
          displayContainer('page-contact-warranty-claim-lot-tag', true);
          displayContainer('page-contact-warranty-claim-impact-area', true);
          document.getElementById('page-contact-warranty-claim-lot-tag-nugget-container').style.display = 'none';
          document.getElementById('page-contact-warranty-claim-lot-tag-chunk-container').style.display = 'inline';
          document.getElementById('tag-lot-container-nugget').style.display = 'none';
        break;
    }

  };

  var modalLinks = document.querySelectorAll('.modalLink');
  for (let i = 0; i < modalLinks.length; i++) {
    modalLinks[i].addEventListener("click", function() {
      document.getElementById(modalLinks[i].dataset.modal).classList.add('cc-popup--visible');
      document.body.classList.add('cc-modal-visible');
    });
  }

  var closeModalLinks = document.querySelectorAll('.cc-popup-close-gg');
  for (let i = 0; i < closeModalLinks.length; i++) {
    closeModalLinks[i].addEventListener("click", function() {
      document.getElementById(closeModalLinks[i].dataset.modalclose).classList.remove('cc-popup--visible');
      document.body.classList.remove('cc-modal-visible');
    });
  }

  var closeModalLinksViaBG = document.querySelectorAll('.cc-popup-background');
  for (let i = 0; i < closeModalLinksViaBG.length; i++) {
    closeModalLinksViaBG[i].addEventListener("click", function() {
      document.getElementById(closeModalLinksViaBG[i].dataset.modalclose).classList.remove('cc-popup--visible');
      document.body.classList.remove('cc-modal-visible');
    });
  }

  function resetAllContainers() {
      const containerItems = document.querySelectorAll("[id$='-container']");
       containerItems.forEach(function(containerItem) {
        containerItem.style.display = "none";
        const hiddenForms = containerItem.querySelectorAll(".required-when-shown");
        hiddenForms.forEach(function(hiddenItem) {
          hiddenItem.required = false;
          hiddenItem.style.display = 'none';
          hiddenItem.disabled = true;
        });
      });
      document.getElementById('page-contact-warranty-claim-what-product-affected').selectedIndex = 0;
      document.getElementById('nugget_form_submit').disabled = false;
      document.getElementById('nugget_form_submit_message').innerHTML = '';
      document.getElementById('nugget_form_submit_message').classList.add('hidden');
   }

  function restrictList(element, limit) {
    try {
      if(element.files.length > limit) {
        alert('You are only allowed to submit ' + limit + ' files');
        element.value = null;
      }
    } catch (e) {
      console.log('Unable to restrict element due to ' + e);
    }
  }

                   
  function displayContainer(container, state, callback) {
    displayState = (!state) ? 'none' : 'block';
    localContainer = document.querySelector('#'+container+'-container');

    if (typeof(localContainer) != null && typeof(localContainer) != 'undefined') {
      localContainer.style.display = displayState;
      localHiddenItems = localContainer.querySelectorAll(".required-when-shown");
      localHiddenItems.forEach(function(localHiddenItem) {
        if (state == true) {
          localHiddenItem.required = true;
          localHiddenItem.disabled = false;
          localHiddenItem.style.display = 'block';
        }
        if (state == false) {
          localHiddenItem.required = false;
          localHiddenItem.disabled = true;
          localHiddenItem.style.display = 'none';
        }
      });
    }
    
    if (callback !== undefined && typeof(callback) == 'function') {
      callback();
    }
  }

  var CancelToken = axios.CancelToken;
 
  var returnsImage = document.querySelector('#returnsImageAdd');
  var impactItem = document.querySelector('#impactImageAdd');
  var contactFormSubmit = document.querySelector('#nugget_form_submit');
  var imageCount = {"impactImage": 1, "lotTag": 1, "returnsImage": 1 };  
  var lotItem = document.querySelector('#lotTagAdd'); 
  var lotImageCount = 1;

  function imageSubmissionCheck() {
    var alertMessage = '';
    // determine whether we can hit the submit button based on images
    if (imageCount.impactImage > 1 && imageCount.lotTag > 1) {
      alertMessage = 'Enable button.';
      document.getElementById('nugget_form_submit').disabled = false;
      document.getElementById('nugget_form_submit_message').innerHTML = '';
      document.getElementById('nugget_form_submit_message').classList.add('hidden');
    }
    else {
      if (imageCount.impactImage == 1 && imageCount.lotTag == 1)
        alertMessage = 'Please add an impact and lot tag image for our team to better assist.';
      if (imageCount.impactImage == 1 && imageCount.lotTag > 1)
        alertMessage = 'Please add an impact image for our team to better assist.';
      if (imageCount.impactImage > 1 && imageCount.lotTag == 1)
        alertMessage = 'Please add a lot image for our team to better assist.';
      document.getElementById('nugget_form_submit').disabled = true;
      document.getElementById('nugget_form_submit_message').classList.remove('hidden');
      document.getElementById('nugget_form_submit_message').innerHTML = 'Please add 1 impact and 1 lot tag image to send a claim.';
    }
  }

  returnsImage.onclick = function(e) {
    var itemName = 'returnsImage';
    var newInput = document.createElement('input');
    newInput.type = 'file';
    newInput.id = itemName + imageCount.returnsImage;
    newInput.name = 'attachment';
    newInput.accept = 'image/png, image/jpeg';
    newInput.hidden = true;
    e.srcElement.parentNode.appendChild(newInput);
    addAndUpload(imageCount.returnsImage, 2, itemName, 'contact_returns_image', newInput);
  }
  
  impactItem.onclick = function(e) {
    var itemName = 'impactImage';
    var newInput = document.createElement('input');
    newInput.type = 'file';
    newInput.id = itemName + imageCount.impactImage;
    newInput.name = 'attachment';
    newInput.accept = 'image/png, image/jpeg';
    newInput.hidden = true;
    e.srcElement.parentNode.appendChild(newInput);
    addAndUpload(imageCount.impactImage, 4, itemName, 'contact_warranty_claim_imact_area', newInput);
  }

  lotItem.onclick = function(e) {
    var itemName = 'lotTag';
    var newInput = document.createElement('input');
    newInput.type = 'file';
    newInput.id = itemName + imageCount.lotTag;
    newInput.name = 'attachment';
    newInput.accept = 'image/png, image/jpeg';
    newInput.hidden = true;
    e.srcElement.parentNode.appendChild(newInput);
    addAndUpload(imageCount.lotTag, 1, itemName, 'contact_warranty_claim_lot_tag', newInput);
  }

  function updateUploadStatus(targetName) {
    var removeLink = document.querySelector('#clickToRemove_' + targetName);
    if (removeLink) {
      removeLink.style.display = 'inline';
    }
    if (itemsUploading < 0) {
      itemsUploading = 0;
    }
    if (itemsUploading > 0) {
      document.querySelector('#nugget_form_submit').classList.add('disabled');
    } else {
      document.querySelector('#nugget_form_submit').classList.remove('disabled');
    }
    // determine if we can enable button
    imageSubmissionCheck();
  }
  
  function addAndUpload(currentItemCount, maxItemCount, targetImageName, formName, targetUpload) {
    if (currentItemCount > maxItemCount) {
      return false;
    }
    targetUpload.click();
    var reader = new FileReader();
    
    targetUpload.onchange = function(e, element) {

      reader.onload = function (readerEvent) {

        var formData = new FormData();        
        formData.append("attachment", readerEvent.target.selectedFile);
        itemsUploading++;
        updateUploadStatus(targetImageName);
        
        var source = CancelToken.source();

        var currentLinkIdenifier = 'id_' + parseInt(Math.random() * 100000);

          var response = axios.post(contactFormLaunchUrl, formData, { 
          cancelToken: source.token,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          
          targetImageCreated: false,
          currentImageId: currentItemCount,
        
          onUploadProgress: function(progressEvent) {
            var self = this;

            if (! self.targetImageCreated) {
              var newImage = document.createElement('img');
              newImage.id = targetImageName + "_image_" + currentLinkIdenifier;
              newImage.src = readerEvent.target.result;
              newImage.style.height = "100px";
              newImage.style.width = "auto";
              newImage.style.opacity = .25;          

              var newImageLink = document.createElement('button');
              newImageLink.style.display = 'block';
              newImageLink.style.verticalAlign = 'top';
              newImageLink.id = 'image_' + currentLinkIdenifier;
              newImageLink.style.cursor = "pointer";
              newImageLink.style.marginBottom = "20px";
              newImageLink.style.marginRight = "20px";
              newImageLink.style.background = "none";
              newImageLink.style.border = "none";
              newImageLink.style.borderRadius = "0";
              newImageLink.style.padding = "0px";
              newImageLink.text = 'Click to remove';
              newImageLink.setAttribute('aria-label', 'Image added, click to remove');
              
              newImageLink.onclick = function() {
                source.cancel('Operation Cancelled By User');
                itemsUploading--;
                updateUploadStatus(targetImageName);
                var localImage = document.querySelector('#' + 'image_' + currentLinkIdenifier);
                var targetUpload = document.querySelector('#' + targetImageName + '_input_' + currentLinkIdenifier);
                
                if (localImage) {
                  localImage.parentNode.removeChild(localImage);
                  imageCount[targetImageName]--;
                  if (currentItemCount <= maxItemCount) {
                    $('#' + targetImageName + 'Add').show();
                  }                     
                } 
                if (targetUpload) {
                  parentNode = targetUpload.parentNode;
                  targetUpload.parentNode.removeChild(targetUpload);         
                }
                // determine if we can enable button
                imageSubmissionCheck();
              };
              
              newImageLink.appendChild(newImage);
              e.target.parentNode.appendChild(newImageLink);
              self.targetImageCreated = true;
              newImageLink.focus();
            } 
          }
        }).then(function (newTarget) {
          
          itemsUploading--;
          updateUploadStatus(targetImageName);
                    
          var newInput = document.createElement('input');
          newInput.id = targetImageName + '_input_' + currentLinkIdenifier;
          newInput.type = 'hidden';
          newInput.name = 'contact[' + targetImageName + currentLinkIdenifier + ']';
          newInput.value = newTarget.data.path;
          
          var targetImage = document.querySelector('#' + targetImageName + "_image_" + currentLinkIdenifier);
          var targetUpload = document.querySelector('#' + targetImageName + newTarget.config.currentImageId);
          var parentNode = null;
          
          if (targetImage) {
            targetImage.style.opacity = 1;
          }
          if (targetUpload) {
            parentNode = targetUpload.parentNode;
            targetUpload.parentNode.removeChild(targetUpload);         
          }

          // add the new input reference
          if (parentNode != null) {
            parentNode.appendChild(newInput);
          }
        })
        .catch(function (t) {
          console.log('FAILURE!');
          console.log(t);
        });        
        imageCount[targetImageName]++;
      }
      if (currentItemCount >= maxItemCount) {
        $('#' + targetImageName + 'Add').hide();
      }
      reader.selectedFile = e.target.files[0];
      reader.readAsDataURL(e.target.files[0]);
 
    }
  }

  window.onload = function() {
    resetAllContainers();
  };
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", relatedProductsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
